import { ColorsState } from '@/vuex/modules/colors'
import State from '@/vuex/modules/state'
import { GetterTree } from 'vuex'

const getters: GetterTree<ColorsState, State> = {
  colors: (state: ColorsState): ColorsState => ({ index: state.index })
}

export default getters
